export default function (event) {
    return !!(event.venueAddress ||
        (event.venueLocationLatitude && event.venueLocationLongitude));
}
